module.exports = __webpack_public_path__ + "img/25-1.f362cfa5.svg";